import type {Json} from "@cm/graph-v3"
import {jsonSchema} from "@cm/graph-v3"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {z} from "zod/v4-mini"
import {JsonNode} from "#template/nodes/json/json-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"
import {priorNodeClassChain} from "#template/versioning"
import type {BuilderInlet} from "#template/runtime-graph/graph-builder"
import type {GraphBuilderScope} from "#template/runtime-graph/graph-builder-scope"
import type {NodeEvaluator} from "#template/node-evaluator"
import type {ValueLikeNode} from "#template/role-markers"
import {valueMarker} from "#template/role-markers"

export type JsonValueParameters = {value: Json}

const jsonValueDefinition: TemplateNodeDefinition<JsonValueParameters> = {
    nodeClass: "JsonValue",
    validation: {
        parameters: z.object({value: jsonSchema}),
        returns: getTemplateNodeReturns(),
    },
    versionChain: priorNodeClassChain("JSONValue"),
}

@registerTemplateGraphNode
export class JsonValue extends JsonNode<JsonValueParameters> implements ValueLikeNode<Json> {
    get [valueMarker]() {
        return true as const
    }

    public override get definition() {
        return jsonValueDefinition
    }

    public override evaluate(_scope: GraphBuilderScope, _evaluator: NodeEvaluator): BuilderInlet<Json | null> {
        return this.parameters.value
    }
}
